export const servlets = {
    genericLists: '/bin/ahs/generic-lists',
};
